import store from '../store';

export default function (to, from, next) {
  if (store.state.member.token) {
    next();
  } else {
    store.dispatch('member/resetState');
    next('/login');
  }
}
